export default "__VITE_PUBLIC_ASSET__96f156d6__"